import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { Art57NodeUtils } from "../Art57NodeUtils";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { DrugIngredient } from "../../../Data/Art57Data/DrugIngredient";
import { CodeName } from "../../../../service/lookup-service/code-name.model";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { DrugIngredientUtil } from "../../../DrugIngredientUtil";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";
import { TreeNode } from "primeng/api";
import { TreeNodeAuthorisedProduct } from "./TreeNodeAuthorisedProduct";
import { TreeNodeDevelopmentProduct } from "./TreeNodeDevelopmentProduct";

export class TreeNodeDrugIngredient extends Art57Node {
  constructor(injector: Injector, parent: Art57Node) {
    super(
      injector,
      new DrugIngredient(new FieldDefinition(injector)),
      'Drug Ingredient'
    );
    this.parent = parent;
    this.labelNodeName = 'Drug Ingredient';
    this.ioc!.get(Art57Section).generateNumColumValue(this);
    this.refreshLabel();
  }

  override refreshLabel(lazy: boolean = true): void {

    let param1 = '';
    let param2 = '';
    let separator = '';

    if (this.data && this.data.model &&
      this.data.model.substancecode &&
      this.data.model.substancecode.value) {
      if (this.data.model.substancecode.name) {
        param1 = this.data.model.substancecode.name;
      } else if (!lazy) {
        this.ioc!.get(LookupGetService).getLookup('substance', this.data.model.substancecode.value + '_1')
          .then((result: CodeName) => {
            if (result && result.name && result.name != '') {
              this.data.model.substancecode.name = result.name;
              this.refreshLabel();
            }
          });
      }
    }

    if (this.data && this.data.model && this.data.model.roleofingredient) {
      param2 = this.ioc!.get(LookupGetService).retrieveValueFromCache('roleofingredient',
        this.data.model.roleofingredient);
    }

    if (param1 != '' || param2 != '') {
      if ((param1 != '') && (param2 != '')) {
        separator = ' - ';
      }
      this.label = param1 + separator + param2;
    } else {
      this.label = this.labelTemplate;
    }

  }

  mask(condition: boolean, value: string): string {
    if (condition) {
      return "***";
    } else {
      return value;
    }
  }

  override getListItem(): any[] {
    DrugIngredientUtil.setStrength(this.ioc!, this.data.model);
    let lowDenominatorUnitSearchedValue = this.data.model.lowAmountConditionalGroup?.lowamountdenomunit?.value;
    let lowDenominatorUnitLookUpWithValues = '';
    switch (this.data.model.strength) {
      case 1:
        lowDenominatorUnitLookUpWithValues = 'unitofmeasurement';
        break;
      case 2:
        lowDenominatorUnitLookUpWithValues = 'unitofpresentation';
        break;
    }

    let highDenominatorUnitSearchedValue = this.data.model.highAmountConditionalGroup?.highamountdenomunit?.value;
    let highDenominatorUnitLookUpWithValues = lowDenominatorUnitLookUpWithValues;

    return [
      this.data.model &&
        this.data.model.substancecode &&
        this.data.model.substancecode.value
        ? this.data.model.substancecode.value
        : '-',
      this.data.model &&
        this.data.model.substancecode &&
        this.data.model.substancecode.value
        ? this.data.model.substancecode.name
        : 'Not selected',
      this.data.model && this.data.model.roleofingredient
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'roleofingredient',
          this.data.model.roleofingredient
        )
        : 'Not selected',
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        this.data.model &&
          this.data.model.concentrationtypecode &&
          this.data.model.concentrationtypecode.value
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'amountvaluetype',
            this.data.model.concentrationtypecode.value
          )
          : '')

      ,
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        this.data.model.lowAmountConditionalGroup &&
          this.data.model.lowAmountConditionalGroup.lowamountnumervalue
          ? this.data.model.lowAmountConditionalGroup.lowamountnumervalue
          : ''),
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        this.data.model.lowAmountConditionalGroup &&
          this.data.model.lowAmountConditionalGroup.lowamountnumerprefix &&
          this.data.model.lowAmountConditionalGroup.lowamountnumerprefix.value
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'amountprefix',
            this.data.model.lowAmountConditionalGroup.lowamountnumerprefix.value
          )
          : ''),
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        this.data.model.lowAmountConditionalGroup &&
          this.data.model.lowAmountConditionalGroup.lowamountnumerunit &&
          this.data.model.lowAmountConditionalGroup.lowamountnumerunit.value
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'amountnumerunit',
            this.data.model.lowAmountConditionalGroup.lowamountnumerunit.value
          )
          : ''),
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        this.data.model.lowAmountConditionalGroup &&
          this.data.model.lowAmountConditionalGroup.lowamountdenomvalue
          ? this.data.model.lowAmountConditionalGroup.lowamountdenomvalue
          : ''),
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        this.data.model.lowAmountConditionalGroup &&
          this.data.model.lowAmountConditionalGroup.lowamountdenomprefix &&
          this.data.model.lowAmountConditionalGroup.lowamountdenomprefix.value
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'amountprefix',
            this.data.model.lowAmountConditionalGroup.lowamountdenomprefix.value
          )
          : ''),
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        lowDenominatorUnitSearchedValue && lowDenominatorUnitLookUpWithValues
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            lowDenominatorUnitLookUpWithValues,
            lowDenominatorUnitSearchedValue
          )
          : ''),
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        this.data.model.highAmountConditionalGroup &&
          this.data.model.highAmountConditionalGroup.highamountnumervalue
          ? this.data.model.highAmountConditionalGroup.highamountnumervalue
          : ''),
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        this.data.model.highAmountConditionalGroup &&
          this.data.model.highAmountConditionalGroup.highamountnumerprefix &&
          this.data.model.highAmountConditionalGroup.highamountnumerprefix.value
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'amountprefix',
            this.data.model.highAmountConditionalGroup.highamountnumerprefix
              .value
          )
          : ''),
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        this.data.model.highAmountConditionalGroup &&
          this.data.model.highAmountConditionalGroup.highamountnumerunit &&
          this.data.model.highAmountConditionalGroup.highamountnumerunit.value
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'amountnumerunit',
            this.data.model.highAmountConditionalGroup.highamountnumerunit.value
          )
          : ''),
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        this.data.model.highAmountConditionalGroup &&
          this.data.model.highAmountConditionalGroup.highamountdenomvalue
          ? this.data.model.highAmountConditionalGroup.highamountdenomvalue
          : ''),
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        this.data.model.highAmountConditionalGroup &&
          this.data.model.highAmountConditionalGroup.highamountdenomprefix &&
          this.data.model.highAmountConditionalGroup.highamountdenomprefix.value
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'amountprefix',
            this.data.model.highAmountConditionalGroup.highamountdenomprefix
              .value
          )
          : ''),
      this.mask(this.data.model &&
        this.data.model.concentrationtypecode &&
        (this.data.model.concentrationtypecode.value === 0),
        highDenominatorUnitSearchedValue && highDenominatorUnitLookUpWithValues
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            highDenominatorUnitLookUpWithValues,
            highDenominatorUnitSearchedValue
          )
          : ''),
    ];
  }

  override cloneNode(newParent: Art57Node): Art57Node {
    let clonedNode: TreeNodeDrugIngredient = new TreeNodeDrugIngredient(
      this.ioc!,
      newParent
    );

    clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));

    clonedNode.refreshLabel();
    clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning || environment.userPreferences.alwaysAutoexpandNodes)


    return clonedNode;
  }

  override getMessage() {
    let data = this.data.model.substancecode ? this.data.model.substancecode : {};
    let substancecode = { substancecode: JSON.parse(JSON.stringify(data)) }
    let concentrationtypecode = null;

    if (this.data.model.concentrationtypecode && this.data.model.concentrationtypecode.value != null) {
      concentrationtypecode = { concentrationtypecode: this.data.model.concentrationtypecode };
    }

    return {
      ...substancecode, ...concentrationtypecode,
      ...this.data.model.lowAmountConditionalGroup,
      ...this.data.model.highAmountConditionalGroup
    };
  }
  override setMessage(jsonObject: any) {

    let defaultJson = {
      substancecode: jsonObject.substancecode,
      roleofingredient: jsonObject.roleofingredient,
      ingredientStrengthInformation: jsonObject.ingredientStrengthInformation,
      concentrationtypecode: jsonObject.concentrationtypecode,
      strength: jsonObject.strength
    };

    let node: TreeNode | null = Art57NodeUtils.findFirstParentNodeOfType(this, TreeNodeAuthorisedProduct || TreeNodeDevelopmentProduct);
    const isInsertOperation =
      (node &&
        node.data &&
        node.data.model &&
        ([1].includes(node.data.model.operationtype)));

    //Removing masking for insert operations
    if (defaultJson &&
      isInsertOperation &&
      defaultJson.concentrationtypecode &&
      defaultJson.concentrationtypecode.value == 0) {

      defaultJson.ingredientStrengthInformation = undefined;
      defaultJson.concentrationtypecode = undefined;
      defaultJson.strength = undefined;


    } else {
      let lowAmountConditionalGroupJSON = {
        lowAmountConditionalGroup: {
          lowamountnumervalue: jsonObject.lowamountnumervalue,
          lowamountnumerprefix: jsonObject.lowamountnumerprefix,
          lowamountnumerunit: jsonObject.lowamountnumerunit,
          lowamountdenomvalue: jsonObject.lowamountdenomvalue,
          lowamountdenomprefix: jsonObject.lowamountdenomprefix,
          lowamountdenomunit: jsonObject.lowamountdenomunit
        }
      };

      if (lowAmountConditionalGroupJSON) {
        Art57NodeUtils.generateFormlyModel(this.data.fields, lowAmountConditionalGroupJSON, this.data.model, 'lowAmountConditionalGroup');
      }

      let highAmountConditionalGroupJSON = {
        highAmountConditionalGroup: {
          highamountnumervalue: jsonObject.highamountnumervalue,
          highamountnumerprefix: jsonObject.highamountnumerprefix,
          highamountnumerunit: jsonObject.highamountnumerunit,
          highamountdenomvalue: jsonObject.highamountdenomvalue,
          highamountdenomprefix: jsonObject.highamountdenomprefix,
          highamountdenomunit: jsonObject.highamountdenomunit
        }
      };

      if (highAmountConditionalGroupJSON) {
        Art57NodeUtils.generateFormlyModel(this.data.fields, highAmountConditionalGroupJSON, this.data.model, 'highAmountConditionalGroup');
      }
    }

    super.setMessage(defaultJson);

  }

  override validateBusinessRules(): any[] {
    const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
    let businessRulesErrors = [];

    if (sameModelValuesBusinessErrors.length > 0) {
      businessRulesErrors.push(...sameModelValuesBusinessErrors);
    }

    return businessRulesErrors;
  }

}